<template>
    <section class="section section-lg bg-default">
        <div class="container container-wide">
            <b-alert :show="!this.isEmpty(form.errors.card_error)" variant="danger" dismissible fade
                v-html="form.errors.card_error"></b-alert>
            <div class="row row-fix row-50 justify-content-lg-center">
                <div v-show="this.paymentPageUnderMaintenance">
                    <div class="maintenance-instruction">
                        <h2>メンテナンスのお知らせ</h2>
                        <ul class="maintenance-description">
                            <li>大変申し訳ございません。</li>
                            <li>メンテナンス中のため、お支払いを完了することができません。</li>
                            <li>メンテナンス終了後再度お試しください。</li>
                        </ul>
                    </div>
                    <div class="maintainance-buttons">
                        <div class="button buttons button-xs button-default-outline change-credit-card mobile-button2"
                            @click="redirect('maintennance_page_account_redirect')">アカウントページに戻る</div>
                    </div>
                </div>
                <div class="row row-fix row-50 justify-content-lg-center" v-show="!this.paymentPageUnderMaintenance">
                    <div class="text-header">
                        <span>{{ this.updateCC ? form.stripeFormDetails.update.instructionTitle :
                            form.stripeFormDetails.payment.instructionTitle }}</span>
                    </div>
                    <div>
                        <div class="intruction-text">{{ this.updateCC ? form.stripeFormDetails.update.instructionDetail
                            :
                            form.stripeFormDetails.payment.instructionDetail }}</div>
                        <div class="instruction-note">
                            ※セキュリティコード（カード認証コード）とは？<br />
                            カードの裏面などに記載されている、数字 3～4桁の認証用コードです。<br />
                            CVC (card verification code) 、CVV (card verification value) などの呼称が用いられる場合もあります。
                        </div>
                    </div>
                    <div v-if="!form.pg_intent_loaded" class="page-loading-indicator">
                        <img src="/images/eowp/animation/loading-spinner.jpg" />
                    </div>
                    <div class="form-container">
                        <!-- PAYMENT FORM -->
                        <form id="payment-form" :class="form.pg_intent_loaded ? '' : 'hidden'">
                            <div class="form-wrap form-wrap-validation">
                                <input class="form-input" id="subscriber-full-name" v-model="form.cardHolderFullName"
                                    type="text" name="card-holder-name" :placeholder="form.cardHolderPlaceholder" />
                            </div>
                            <div>
                                <div id="card-number-element" class="card-element"></div>
                            </div>
                            <div class="flex-elements">
                                <div id="card-expiry-element" class="card-element"></div>
                                <div id="card-cvc-element" class="card-element"></div>
                            </div>

                            <!-- Card Errors (Error Message Display for 3D Secure or Payment Errors) -->
                            <div id="card-errors" role="alert" aria-live="polite" class="form-errors"></div>

                            <!-- Submit Button -->
                            <button id="submit"
                                :disabled="form.button_disabled || form.loading || !form.cardHolderFullName || !formInputsVerified()">
                                <div class="spinner" :class="form.loading ? '' : 'hidden'" id="spinner"></div>
                                <span id="button-text" :class="form.loading ? 'hidden' : ''">
                                    {{ this.updateCC
                                        ? form.stripeFormDetails.update.button
                                        : form.stripeFormDetails.payment.button }}
                                </span>
                            </button>
                        </form>
                    </div>
                    <div class="logos">
                        <div class="payment-method">
                            <img src="/images/stripe/visa.png" id="visa" />
                            <img src="/images/stripe/mastercard.png" id="mastercard" />
                            <img src="/images/stripe/jcb.png" id="jcb" />
                            <img src="/images/stripe/discover.png" id="discover" />
                            <img src="/images/stripe/amex.png" id="amex" />
                            <img src="/images/stripe/diners.gif" id="diners" />
                        </div>
                        <img src="/images/stripe/stripe.png" id="stripe" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.maintenance-description {
    max-width: 500px;
    position: relative;
    display: inline-block;
    text-align: left;
    margin-top: 40px;
    margin-bottom: 20px;
}

.maintenance-description li {
    padding-top: 15px;
}

.maintenance-instruction {
    position: relative;
    display: block;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 30px;
}

.maintenance-instruction span {
    padding-top: 35px !important;
    padding-bottom: 40px !important;
    position: relative;
    display: block;
}

.maintainance-buttons div.button {
    max-width: 320px;
}

section {
    padding-top: 25px !important;
    text-align: center;
}

.form-container {
    width: 100%;
    position: relative;
    display: block;
    text-align: -webkit-center;
    text-align: -moz-center !important;
}

.text-header {
    width: 100%;
    position: relative;
    display: block;
    text-align: center;
    font-size: 25px;
    margin-bottom: 10px;
    padding-top: 20px !important;
}

.text-instruction {
    width: 100%;
    position: relative;
    display: block;
    text-align: center;
    font-size: 14px;
}

.instruction-note {
    margin-top: 20px;
    font-size: 14px;
    max-width: 780px;
    position: relative;
    display: inline-flex;
}

@media (max-width: 496px) {
    .instruction-note br {
        display: none;
    }
}

.page-loading-indicator {
    width: 100%;
    position: relative !important;
    display: block !important;
    text-align: center;
    position: relative;
    display: inline-flex;
}

.page-loading-indicator>img {
    width: 50px;
}

form {
    width: 30vw;
    min-width: 500px;
    align-self: center;
    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
        0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
    border-radius: 7px;
    padding: 40px;
    margin-right: 3px;
}

input {
    border-radius: 6px;
    margin-bottom: 6px;
    padding: 12px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    height: 44px;
    font-size: 16px;
    width: 100%;
    background: white;
}

.hidden {
    display: none;
}

#card-element {
    border-radius: 4px 4px 0 0;
    padding: 12px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    height: 44px;
    width: 100%;
    background: white;
}

#payment-request-button {
    margin-bottom: 32px;
}

/* Buttons and links */
button {
    background: #5469d4;
    color: #ffffff;
    font-family: Arial, sans-serif;
    border-radius: 0 0 4px 4px;
    border: 0;
    padding: 12px 16px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: block;
    transition: all 0.2s ease;
    box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
    width: 100%;
}

button:hover {
    filter: contrast(115%);
}

button:disabled {
    opacity: 0.5;
    cursor: default;
}

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
    border-radius: 50%;
}

.spinner {
    color: #ffffff;
    font-size: 22px;
    text-indent: -99999px;
    margin: 0px auto;
    position: relative;
    width: 20px;
    height: 20px;
    box-shadow: inset 0 0 0 2px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
}

.spinner:before,
.spinner:after {
    position: absolute;
    content: "";
}

.spinner:before {
    width: 10.4px;
    height: 20.4px;
    background: #5469d4;
    border-radius: 20.4px 0 0 20.4px;
    top: -0.2px;
    left: -0.2px;
    -webkit-transform-origin: 10.4px 10.2px;
    transform-origin: 10.4px 10.2px;
    -webkit-animation: loading 2s infinite ease 1.5s;
    animation: loading 2s infinite ease 1.5s;
}

.spinner:after {
    width: 10.4px;
    height: 10.2px;
    background: #5469d4;
    border-radius: 0 10.2px 10.2px 0;
    top: -0.1px;
    left: 10.2px;
    -webkit-transform-origin: 0px 10.2px;
    transform-origin: 0px 10.2px;
    -webkit-animation: loading 2s infinite ease;
    animation: loading 2s infinite ease;
}

@-webkit-keyframes loading {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes loading {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@media only screen and (max-width: 600px) {
    form {
        width: 80vw;
    }
}

.row {
    display: block;
    margin-left: auto;
    margin-right: auto
}

article {
    padding-top: 150px;
    padding-bottom: 150px;
}

.maintainance-buttons {
    padding-top: 40px;
    margin: 0 auto;
    display: inline-grid;
}

@media (max-width: 536px) {
    form {
        min-width: 460px !important;
    }
}

@media (max-width: 483px) {
    form {
        min-width: 380px !important;
    }
}

@media (max-width: 404px) {
    form {
        min-width: 334px !important;
    }
}

@media (min-width: 240px) and (max-width: 360px) {
    form {
        min-width: 280px !important;
        padding: 20px !important;
    }
}

@media (min-width: 150px) and (max-width: 336px) {
    form {
        min-width: 220px !important;
    }
}

/** Images and logos */
.logos #stripe {
    filter: opacity(0.5);
    width: 155px;
}

.logos .payment-method {
    margin: 30px auto;
    display: flex;
    justify-content: center;
    gap: 40px;
}

.logos .payment-method img {
    object-fit: contain;
    filter: opacity(0.5) grayscale(1);
}

.logos .payment-method #mastercard,
.logos .payment-method #jcb {
    width: 37px;
}

.logos .payment-method #visa,
.logos .payment-method #discover {
    width: 45px;
}

.logos .payment-method #amex {
    width: 38px;
}

.logos .payment-method #diners {
    width: 40px;
}

@media (max-width: 490px) {
    .logos .payment-method {
        gap: 30px;
    }
}

@media (max-width: 440px) {
    .logos .payment-method {
        gap: 15px;
    }
}

@media (max-width: 355px) {
    .logos .payment-method {
        gap: 10px;
    }

    .logos .payment-method img {
        max-width: 60px;
    }
}

form#payment-form .card-element {
    border-radius: 6px;
    margin-bottom: 6px;
    padding: 12px;
    padding-top: 17px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    height: 55px;
    font-size: 16px;
    width: 100%;
    background: white;

}

@media only screen and (min-width: 484px) {
    form#payment-form .flex-elements {
        position: relative;
        display: flex;
    }

    form#payment-form div#card-expiry-element {
        width: 50% !important;
        position: relative;
        display: inline;
        margin-right: 3px;
    }

    form#payment-form div div#card-cvc-element {
        width: 50% !important;
        position: relative;
        display: inline;
        margin-left: 3px;
    }
}

@media only screen and (max-width: 483px) {
    form#payment-form div#card-number-element {
        padding-left: 10px !important;
    }
}
</style>

<!-- Non-Scoped CSS, not limited to this vue component only -->
<style>
/** Suppress effects of br tag when browser width shrinks to given px and below */
@media only screen and (max-width: 856px) {
    section.section div.container div.alert br {
        position: relative !important;
        display: none !important;
    }
}
</style>

<script>
import { BAlert } from "bootstrap-vue";
import Utils from '../../../js/helpers/Utils';
import PageControl from '../../../js/helpers/PageControl';
import { mapActions, mapGetters } from "vuex";
import BaseModel from '../../../js/models/BaseModel';
import DialogMixin from '../../../js/helpers/mixins/DialogMixin';
import StripeErrorMixin from "../../../js/helpers/mixins/StripeErrorMixin";
import PaymentManager from "../../../js/helpers/PaymentManager";
export default {
    data() {
        return {
            paymentPageUnderMaintenance: '',
            form: {
                button_disabled: true,
                pg_intent_loaded: false,
                errors: {
                    card_error: '',
                    stripe_errors: {
                        incomplete: '処理を完了することができませんでした。<br />お手数ですが、カード会社にお問い合わせいただくか、別のクレジットカードをご利用ください。', // the process was not able to complete. please check with your card company or use another credit card.
                        default: '処理を完了することができませんでした。<br />時間を置いてお試しいただきますようお願いいたします。<br />解決しない場合はお手数ですが、<a target="_blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">英辞郎 on the WEBお問い合わせフォーム</a>からお問い合わせください。' // the process was not able to complete. please try again after some time. if this does not solve the problem, please contact us through the inquiry form
                    },
                    payment_errors: {
                        ERROR29: 'このクーポンは使用できなくなりました。', 
                        ERROR30: 'このクーポンは使用できなくなりました。', 
                        ERROR3_YEARLY: '年額コースは、ご利用中のサブスクリプションと重複するためご購入いただけません。<a href="/account">アカウントページ</a>でご利用状況をご確認ください。<br/>解決しない場合やご不明の点がある場合は、お手数ですが、<a target="_blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">「英辞郎 on the WEB」お問い合わせフォーム</a>からご連絡をお願いします。', //Yearly cannot be purchased because it duplicates a subscription you are currently using. Please check your usage status on your account page.
                        ERROR3_MONTHLY: '月額コースは、ご利用中のサブスクリプションと重複するためご購入いただけません。<a href="/account">アカウントページ</a>でご利用状況をご確認ください。<br/>解決しない場合やご不明の点がある場合は、お手数ですが、<a target="_blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">「英辞郎 on the WEB」お問い合わせフォーム</a>からご連絡をお願いします。', //Monthly cannot be purchased because it duplicates a subscription you are currently using. Please check your usage status on your account page.
                        ERROR16_29: '処理中にシステム上の不具合が発生しました。<br />おそれいりますが、再操作を行わず、この状態のまま<a target="_blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">「英辞郎 on the WEB Pro」お問い合わせフォーム</a>からご連絡ください。<br />※再操作を行うと重複決済等につながる可能性がございます。', //We have encountered an unexpected error while we are trying to sync the purchased subscription to our system. Please do not attempt to purchase new one, and report this issue to our administrator immediately with the following information.
                        ERROR16_32: '購入手続きが完了しませんでした。同じ申し込みを既に受け付けています。<br />アカウントページで、最新の注文の状況を確認してください。<br />解決しない場合はお手数ですが、<a target="_blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">こちらから</a>お問い合わせくださいますようお願いいたします。', //The purchase process was not completed. The same application has already been accepted. Please check the status of your most recent order on your account page. If the problem persists, please contact us.
                        ERROR33_MONTHLY: '月額コースは、ご利用中のサブスクリプションと重複するためご購入いただけません。<br /><a href="/account">アカウントページ</a>でご利用状況をご確認ください。解決しない場合やご不明の点がある場合は、<br />お手数ですが、「英辞郎 on the WEB」お問い合わせフォームからご連絡をお願いします。', // You cannot purchase the monthly course as it overlaps with your current subscription. Please check your usage status on your account page. If the problem is not resolved, please contact us using the "Eijiro on the WEB" inquiry form.
                        ERROR33_YEARLY: '年額コースは、ご利用中のサブスクリプションと重複するためご購入いただけません。<br /><a href="/account">アカウントページ</a>でご利用状況をご確認ください。解決しない場合やご不明の点がある場合は、<br />お手数ですが、「英辞郎 on the WEB」お問い合わせフォームからご連絡をお願いします。', // You cannot purchase the yearly course as it overlaps with your current subscription. Please check your usage status on your account page. If the problem is not resolved, please contact us using the "Eijiro on the WEB" inquiry form.
                        NETWORK_ERROR: '通信障害により処理の完了を確認できませんでした。<br />恐れ入りますが、<a href="/account">アカウントページ</a>にてご購入の有無をご確認の上再度お試しください。<br />解決しない場合はお手数ですが、<a target="_blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">英辞郎 on the WEBお問い合わせフォーム</a>からお問い合わせください。', // Due to network issue, we could not confirm the completion of the process. Please check your account page to see if you have a subscription purchased. If the problem persists, please contact us using the Eijiro on the WEB Contact Form.
                        card_declined: '処理を完了することができませんでした。<br />お手数ですが、カード会社にお問い合わせいただくか、別のクレジットカードをご利用ください。', // the process was not able to complete. please check with your card company or use another credit card.
                        default: '処理を完了することができませんでした。<br />時間を置いてお試しいただきますようお願いいたします。<br />解決しない場合はお手数ですが、<a target="_blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">英辞郎 on the WEBお問い合わせフォーム</a>からお問い合わせください。' // the process was not able to complete. please try again after some time. if this does not solve the problem, please contact us through the inquiry form
                    }
                },
                loading: false,
                cardHolderFullName: '',
                stripeFormDetails: {
                    payment: {
                        instructionTitle: 'サブスクリプションお申し込み（クレジットカード決済）', //Subscription application (Credit Card Payment)
                        instructionDetail: 'クレジットカードに記載された「カード名義」「カード番号」「月／年」「CVC（セキュリティコード）」を入力してください。', //Please enter the "Card Holder (Name)", "Card Number", "Month/Year" and "CVC (Security Code)" on your credit card.
                        button: '注文' //pay now
                    },
                    update: {
                        instructionTitle: 'ご利用カード情報の更新', //Update Credit Card Information
                        instructionDetail: 'クレジットカードに記載された「カード名義」「カード番号」「月／年」「CVC（セキュリティコード）」を入力してください。', //Please enter the "Card Holder (Name)", "Card Number", "Month/Year" and "CVC (Security Code)" on your credit card.
                        button: '更新' //update now
                    }
                },
                cardHolderPlaceholder: 'カード名義', //Cardholder's Full Name
                inputElements: {
                    status: {
                        cardNumber: false,
                        cardExpiry: false,
                        cardCvc: false,
                    }
                },
            },
            eowp: {
                item: {
                    id: '',
                    name: '',
                    price: '',
                    userId: '',
                    userEmail: '',
                    userName: ''
                },
                stripeControlCode: '',
                stripeControlName: 'stripe_payment_gateway',
                autoSyncQueue: {
                    SUCCEEDED: "SUCCEEDED",
                    statusCodes: {
                        ERROR16_30: "SUCCEEDED",
                        ERROR16_31: "SUCCEEDED",
                    },
                },
            },
        };
    },
    async created() {
        if (Utils.isEmpty(this.updateCC) && (Utils.isEmpty(this.chosenItem) || Utils.isEmpty(this.itemCharge) || !this.readAgreement)) {
            this.$router.push("/basket");
            return;
        }

        // Determine if this user has pending subscription for sync - hard redirect to account page instead
        await this.pendingSubscriptionSync({ userId: this.sessionDetails.userId, sessionId: this.sessionDetails.sessionId }).then(res => {
            if (res.SYNC && res.SYNC > 0) { window.location.href = "/"; return; }
        });

        let userData = {
            userId: this.sessionDetails.userId,
            sessionId: this.sessionDetails.sessionId,
            action: this.eowp.stripeControlName
        };
        await this.verifyAccess(userData).then(res => {
            this.paymentPageUnderMaintenance = res.status_code != "ERR0";
        });

        await this.fetchUserDetails({ sessionId: this.userDetails.sessionId, email: this.userEmail }).then(res => {
            //Make sure it's legit active user session
            if (res.status != BaseModel.STATUS_SUCCESS) {
                this.$router.push("/signout");
                return;
            }
            this.eowp.item.userId = res.records.id;
            this.eowp.item.userEmail = res.records.email;
            this.eowp.item.userName = res.records.name;
        });

        if (Utils.isEmpty(this.updateCC)) {
            await this.retrieveProduct(this.chosenItem).then(res => {
                if (!res.records || Utils.isEmpty(res.records.csMatNo) || Utils.isEmpty(res.records.productName) || Utils.isEmpty(res.records.productPriceWithTax)) {
                    this.$router.push("/basket");
                    return;
                } else {
                    this.eowp.item.id = res.records.csMatNo;
                    this.eowp.item.name = res.records.productName;
                    this.eowp.item.price = res.records.productPriceWithTax;
                    this.eowp.item.basePrice = res.records.productPrice;

                    //TODO: Enable below once confirmed we need to charge them even 0, let's find ways how to incorporate this one on #169
                    //this.eowp.item.price = this.itemCharge; 
                }
            });
        }

        this.getPGClientKey().then(() => {
            if (typeof window.Stripe !== 'function') {
                let vm = this;
                window.jQuery("script#spScript1").ready(() => {
                    let intervalid = setInterval(() => {
                        if (typeof window.Stripe === 'function') {
                            clearInterval(intervalid);
                            vm.form.pg_intent_loaded = true;
                            vm.initStripe();
                        }
                    }, 5);
                });
            } else {
                this.form.pg_intent_loaded = true;
                this.initStripe();
            }
        });

        this.logActivity({ type: "info", message: " Loaded payments page on " + (this.updateCC ? "Change Card Info" : "Purchase") + " mode with userId: " + this.sessionDetails.userId + ", sessionId: " + this.sessionDetails.sessionId });
    },
    watch: {
        sessionDetails: function (sessionValue) {
            new PageControl(this).validateSession(sessionValue);
        }
    },
    mounted() {
        if (typeof window.Stripe !== 'function') {
            Utils.loadScript("https://js.stripe.com/v3/", "spScript1");
        }
    },
    computed: {
        ...mapGetters({
            clientKey: 'pg/client_key',
            intentKey: 'pg/intent_key',
            itemCharge: 'pg/item_charge',
            freeMonth: 'pg/free_month',
            updateCC: 'pg/update_cc',
            readAgreement: 'pg/read_agreement',
            chosenItem: 'ncs/chosen_item',
            product: 'ncs/product',
            userDetails: 'user/session_details',
            userEmail: 'user/user',
            productTypes: 'ncs/product_types',
            sessionDetails: 'user/session_details',
            savedPromoCode: 'coupon/promo_code',
            savedCouponId: 'coupon/coupon_id',
        })
    },
    methods: {
        ...mapActions({
            getPGClientKey: 'pg/getPGClientKey',
            beforeCreateSubscriptionChecks: 'pg/beforeCreateSubscriptionChecks',
            createSubscription: 'pg/createSubscription',
            postCreateSubscriptionChecks: 'pg/postCreateSubscriptionChecks',
            cancelSubscription: 'pg/cancelSubscription',
            setPaymentSuccessFlag: 'pg/setSuccessFlag',
            updatePaymentMethod: 'pg/updatePaymentMethod',
            finalizeUpdatePaymentMethod: 'pg/finalizeUpdatePaymentMethod',
            pendingSubscriptionSync: 'pg/pendingSubscriptionSync',
            retrieveProduct: 'ncs/retrieveProduct',
            fetchUserDetails: 'user/fetchUserDetails',
            getNewOrderId: 'ncs/getNewOrderId',
            logActivity: 'log/logActivity',
            setPathIntention: 'user/setPathIntention',
            trackClickEvent: 'ga/trackClickEvent',
            retrieveControllerDetails: 'control/retrieveControllerDetails',
            verifyAccess: 'user/verifyAccess',
            createSetupIntent: 'pg/createSetupIntent'
        }),

        // Stripe Initialization: The initStripe method is called, which creates instances of card number, expiry, and CVC elements.
        initStripe() {
            let stripe = window.Stripe(this.clientKey); // Stripe public key loaded from the backend
            let vm = this;

            let elements = stripe.elements();
            let style = {
                base: {
                    color: "#32325d",
                    fontFamily: 'Arial, sans-serif',
                    fontSmoothing: "antialiased",
                    fontSize: "16px",
                    "::placeholder": {
                        color: "#888888"
                    },
                    ":-webkit-autofill": {
                        color: '#000000',
                    },
                },
                invalid: {
                    fontFamily: 'Arial, sans-serif',
                    color: "#fa755a",
                    iconColor: "#fa755a"
                }
            };

            const cardNumber = elements.create('cardNumber', { showIcon: true, placeholder: 'Card Number', disableLink: true, style: style });
            const cardExpiry = elements.create('cardExpiry', { style: style });
            const cardCvc = elements.create('cardCvc', { style: style });

            cardNumber.mount('#card-number-element');
            cardExpiry.mount('#card-expiry-element');
            cardCvc.mount('#card-cvc-element');

            cardNumber.on("change", event => vm.verifyInput(event));
            cardExpiry.on("change", event => vm.verifyInput(event));
            cardCvc.on("change", event => vm.verifyInput(event));

            let form = document.getElementById("payment-form");
            form.addEventListener("submit", (event) => this.handleSubmit(event, stripe, cardNumber));
        },
        verifyInput(event) {
            // Disable the Pay button if there are no card details in the Element
            this.form.inputElements.status[event.elementType] = event.elementType && event.complete;

            if (event.error) {
                event.error.message = this.form.errors.stripe_errors[event.error.code] ? this.form.errors.stripe_errors[event.error.code] : event.error.message;
                // Replace error code with decline code if defined
                const stripeError = event.error.code ? this.getStripeError(event.error.code) : null;
                event.error.code = stripeError ? stripeError.code : event.error.code;
            }
            this.errorMessage(event);
        },
        errorMessage(result) {
            this.form.errors.card_error = '';
            this.form.button_disabled = result.empty || !result.complete;
            if (result.error) {
                this.form.errors.card_error = result.error.message ? result.error.message : this.form.errors.payment_errors['default'];
                if (result.error.code) {
                    this.form.errors.card_error += ' (error_code: ' + result.error.code + ')';
                    if(result.error.code == 'ERROR29' || result.error.code == 'ERROR30'){
                        this.form.errors.card_error += '<a style="color: #843131; cursor: pointer;" href="javascript:history.back()">「<span style="text-decoration:underline" >前の画面に戻る</span>」</a>'
                    }
                }
            }
        },
        formInputsVerified() {
            return this.form.inputElements.status.cardNumber &&
                this.form.inputElements.status.cardExpiry &&
                this.form.inputElements.status.cardCvc;
        },
        loadingIndicator(flag) {
            this.form.loading = flag;
        },
        isEmpty(object) {
            return Utils.isEmpty(object);
        },
        redirect(eventName) {
            this.trackClickEvent({ event: eventName, path: this.$route.path, title: this.$route.meta.title });
            this.$router.push("/account");
        },
        handleSubmit(event, stripe, cardNumber) {
            this.loadingIndicator(true);
            event.preventDefault();
            this.form.errors.card_error = '';
            // Complete payment when the submit button is clicked
            this.checkActiveSession().then(isActive => {
                if (!isActive) {
                    this.loadingIndicator(false);
                    return;
                }

                const paymentManager = new PaymentManager(stripe, this);

                if (!Utils.isEmpty(this.updateCC)) {
                    paymentManager.updateCustomerCC(stripe, cardNumber);
                } else {
                    paymentManager.processPayment(cardNumber);
                }
            });
        },

    },
    components: {
        BAlert
    },
    mixins: [
        DialogMixin, StripeErrorMixin
    ]
};
</script>
